import {useEffect} from 'react';

import {useViewportSize} from '../../../hooks';
import {getObjectValues} from '../../../utils';

function useMediaActions(data) {
    const {
        events: {
            onSettingsChange
        },
        options,
        initialSettings,
        changeSettings
    } = data;

    const viewportSize = useViewportSize();

    function setSettings(nextSettings) {
        changeSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialSettings);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialSettings)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function calculateSettings() {
        const {
            smallBreakpoint,
            largeBreakpoint
        } = options;

        const {
            width,
            height
        } = viewportSize;

        const isMobile = width < smallBreakpoint;
        const isTablet = width >= smallBreakpoint && width < largeBreakpoint;
        const isDesktop = width >= largeBreakpoint;

        const nextSettings = {
            width,
            height,
            isMobile,
            isTablet,
            isDesktop
        };

        setSettings(nextSettings);
    }, [...getObjectValues(options), ...getObjectValues(viewportSize)]);
    /* eslint-enable react-hooks/exhaustive-deps */
}

export {useMediaActions};
